import React from 'react';
import { Link } from 'react-router-dom';
import './HomeFooter.css';

// Multi-column footer: brand block, link columns, contact.
const HomeFooter = () => (
    <footer className="gh-footer">
        <div className="gh-footer-inner">
            <div className="gh-footer-brand">
                <span className="gh-footer-logo">Gradies</span>
                <p className="gh-footer-tag">Pokémon, Trainers, Energies</p>
                <p className="gh-footer-legal">© {new Date().getFullYear()} Gradies. All rights reserved.</p>
            </div>

            <div className="gh-footer-col">
                <h4>Shop</h4>
                <Link to="/pokemon">Pokémon</Link>
                <Link to="/trainer">Trainers</Link>
                <Link to="/energy">Energies</Link>
                <Link to="/promo">Promos</Link>
                <Link to="/sets">Sets</Link>
            </div>

            <div className="gh-footer-col">
                <h4>Get in touch</h4>
                <p className="gh-footer-contact">Questions or feedback? We'd love to hear from you.</p>
                <a href="mailto:support@gradies.com">support@gradies.com</a>
            </div>

            <div className="gh-footer-col">
                <h4>Legal</h4>
                <Link to="/guarantee">Buyer Trust Guarantee</Link>
                <Link to="/terms">User Agreement</Link>
                <Link to="/privacy">Privacy Policy</Link>
            </div>
        </div>
    </footer>
);

export default HomeFooter;
